
<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Your Image">
  <div class="image-text">
    <p>About Institution</p>
  </div>
</div>    

<div class="container-fluid text-center mt-5" *ngIf="pageData$ | async">
  <img 
    [src]="aboutImages[0] || ''" 
    style="width: 60%; height: 20%; object-fit: fill;" 
    alt="">
</div>

<!-- ================= OUR AIM ================= -->

<div class="container-fluid ">
  <div class="row p-4" style="margin-bottom: 1vh;">

    <div class="col-lg-6 col-sm-12 col-md-6 text-center">
        <img 
          [src]="getImage(aimCategory, 'assets/our aim.png')" 
          width="100%" 
          alt="" class="category-img">
    </div>
 
    <div class="col-lg-6 col-sm-12 col-md-6 mt-2">
      <div class="section-heading">
         <u>&nbsp;&nbsp;Our</u>&nbsp;<u>Aim&nbsp;&nbsp;</u>
      </div>

       <div class="message-text">
        <ng-container *ngIf="aimCategory?.content?.[0] as aimContent; else defaultAim">
          <div [innerHTML]="aimContent.content"></div>
        </ng-container>

        <ng-template #defaultAim>
          Education is a life – long journey and the School realizes the importance of a good start. It is here that the foundation for the love of learning is laid and strengthened.
          The classrooms, laboratories, activity rooms, etc., are designed for greater efficiency and to protect children from air and noise pollution. Our pupils are encouraged and guided to develop their analytical and problem-solving skills.
        </ng-template>
       </div>
    </div>
  </div>
</div>

<!-- ================= OUR MISSION ================= -->

<div class="container-fluid ">
  <div class="row p-4" style="margin-bottom: 1vh;">

    <div class="mob col-lg-6 col-sm-12 col-md-6">
      <img 
        [src]="getImage(missionCategory, 'assets/our mission.png')" 
        width="100%" 
        alt="" class="category-img">
   </div>

    <div class="col-lg-6 col-sm-12 col-md-6 ps-5 px-4 mt-2">
      <div class="section-heading">
        <u>&nbsp;&nbsp;Our</u>&nbsp;<u>Mission&nbsp;&nbsp;</u>
      </div>

       <div class="message-text">
        <ng-container *ngIf="missionCategory?.content?.[0] as missionContent; else defaultMission">
          <div [innerHTML]="missionContent.content"></div>
        </ng-container>

        <ng-template #defaultMission>
          Special tutorial/remedial teaching both during teaching and after school hours is arranged according to the need of each child. Students are engaged in constructive activities that stimulate them intellectually.
          Subjects like English, Hindi, Math, E.V.S., General Knowledge, and Computers are taught to broaden their perspective and equip them for real-life situations.
          A wide range of co-curricular activities ensures the wholesome all-round development of students.
        </ng-template>
       </div>
    </div>
    
    <div class="desktop col-lg-5 col-sm-12 col-md-6 px-4">
      <img 
        [src]="getImage(missionCategory, 'assets/our mission.png')" 
        width="100%" 
        alt="" class="category-img">
  </div>
  </div>
</div>

<!-- ================= OUR VISION ================= -->

<div class="container-fluid ">
  <div class="row p-4" style="margin-bottom: 1vh;">

    <div class="col-lg-6 col-sm-12 col-md-6 text-center">
        <img 
          [src]="getImage(visionCategory, 'assets/our vision.png')" 
          width="100%" 
          alt="" class="category-img">
    </div>
 
    <div class="col-lg-6 col-sm-12 col-md-6 mt-2">
      <div class="section-heading">
        <u>&nbsp;&nbsp;Our</u>&nbsp;<u>Vision&nbsp;&nbsp;</u>
      </div>

       <div class="message-text">
        <ng-container *ngIf="visionCategory?.content?.[0] as visionContent; else defaultVision">
          <div [innerHTML]="visionContent.content"></div>
        </ng-container>

        <ng-template #defaultVision>
          Our academic program is designed to teach students the knowledge, skills, and attitudes that prepare them for success in a global society.
          Faculty and staff with outstanding credentials guide students across all disciplines and foster both academic and personal growth.
          We support teachers through ongoing professional development in pedagogy, inclusion, equity, technology, and subject expertise.
          We strive to create an equitable learning environment where every student has the opportunity to participate and contribute meaningfully to school life.
        </ng-template>
       </div>
    </div>
  </div>
</div>
